import { StrapiLandingBaseModel } from 'strapi/types';

export default function getRelatedColors(
  colors: StrapiLandingBaseModel[],
  category: string,
  hex: string,
) {
  const relatedColors: StrapiLandingBaseModel[] = [];
  colors.map(item => {
    if (category === item?.colorData.category && hex !== item?.colorData.hex) {
      relatedColors.push(item);
    }
    return relatedColors;
  });

  return relatedColors;
}
